import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UiState } from '../state/ui.state';

export const selectUiState = createFeatureSelector<UiState>('ui');

export const selectTheme = createSelector(selectUiState, state => state.theme);
export const selectConversationDialogOpened = createSelector(selectUiState, state => state.isConversationDialogOpened);
export const selectNightShiftTimerActive = createSelector(selectUiState, state => state.nightShiftTimerActive);
